import CopyTextIcon from '@root/assets/svg/Navigation/CopyTextIcon';
import { Input } from '@root/components/v3/input';
import { Label } from '@root/components/v3/label';
import { useCallback } from 'react';
import { toast } from 'sonner';

type FieldProps = {
  name: string;
  value: string;
  showCopy?: boolean;
  disabled?: boolean;
};

const Fields = ({ name, value, showCopy, disabled }: FieldProps) => {
  const handleCopy = useCallback(async () => {
    if (!value) return;
    toast.info('Copied to clipboard');
    await navigator.clipboard.writeText(value);
  }, [value]);

  return (
    <div className="ProfileFields__Container">
      <Label className="ProfileFields__Label">{name}</Label>
      <div className="ProfileFields__InputContainer">
        <Input
          type="text"
          value={value}
          disabled={disabled}
          className="ProfileFields__Input"
          style={{ color: disabled ? '#A3A6AB' : '#1A202C' }}
          readOnly
        />
        {showCopy && (
          <CopyTextIcon onClick={handleCopy} style={{ cursor: 'pointer' }} className="ProfileFields__CopyIcon" />
        )}
      </div>
    </div>
  );
};

export default Fields;
